import React, { Component } from 'react';
import _ from 'lodash';
import { AxlPanel } from 'axl-reactjs-ui';
import { inject, observer } from 'mobx-react';

// Styles
import styles from './styles';
import EventTemplates from '../EventTemplates';
import { EVENT_TEMPLATE_OWNERS, EVENT_TEMPLATE_TARGETS } from '../../constants/eventTemplate';
import { getShipmentHistory } from '../../stores/api';

@inject("userStore")
@observer
class ShipmentHistoryInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: this.props.isOpen
    }
  }

  render() {
    const { shipment, showActualDropoffInfo } = this.props;
    const { client } = this.props.userStore;
    return  <AxlPanel style={styles.panelContainer}>
      <div style={styles.panelHeader}>
        <div style={styles.panelHeaderTitle}>Shipment History</div>
        <div style={styles.panelHeaderRight}>
          <div style={styles.panelHeaderArrow} onClick={() => this.setState({showPanel: !this.state.showPanel})}><i className={!this.state.showPanel ? 'fa fa-angle-down' : 'fa fa-angle-up'} /></div>
        </div>
      </div>
      { this.state.showPanel && <AxlPanel.Row style={styles.panelContent}>
        <AxlPanel.Col flex={1}>
          <EventTemplates
            getEventList={getShipmentHistory} 
            isSearch={false} 
            historyId={shipment?.id}
            targets={[EVENT_TEMPLATE_TARGETS.CLIENT_APP]}
            owners={[`${EVENT_TEMPLATE_OWNERS.CLIENT}${client?.id}`]}
            showActualDropoffInfo={showActualDropoffInfo}
          />
        </AxlPanel.Col>
      </AxlPanel.Row>}
    </AxlPanel>
  }
}

export default ShipmentHistoryInfo;
